import React from 'react';
import './LinkSectionList.less';

export const LinkSectionList = ({ navItem, index, isActive }) => {
  if (!navItem || navItem.HasProductSection || navItem.LinkSections?.length < 1) return null;

  const bottomLinks = navItem.LinkSections.filter((link) => link.PlaceLinkInBottom);
  const displayLinksWithImages = navItem.LinkSections.some((x) => x.ShowLinkImage);

  return (
    <>
      <ul className={`linkSection${displayLinksWithImages ? ' images' : ''} `}>
        {navItem.LinkSections.map((link, i) => (
          <li className={`${isActive ? '' : 'd-none'}`} key={i}>
            {link.SubLinks?.length > 0 ? (
              <button
                onClick={() => {
                  setSelectedLinkSection(link);
                  setMenuLevel(3);
                }}
                className={`btn navigationItem`}
              >
                <span className="navigationHeading">{link.Title}</span>
                <i className="le-icon-chevron rot-180"></i>
              </button>
            ) : (
              <LinkSectionItem linkSection={link} />
            )}
          </li>
        ))}
      </ul>
      {bottomLinks.length ? (
        <ul className={`navigationBottom ${isActive ? '' : 'd-none'} bg-color--${index}`}>
          {bottomLinks.map((link, i) => (
            <li key={i}>
              <a
                onClick={() => setSelectedLink(link.EnglishTitle)}
                href={link.Link}
                className={`navigationItem navigationParagraph`}
              >
                {link.Title}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <></>
      )}
    </>
  );
};

const LinkSectionItem = ({ linkSection }) => {
  if (!linkSection?.Link) return null;

  if (linkSection.PlaceLinkInBottom) return null;

  if (linkSection.ShowLinkImage) {
    return (
      <a onClick={() => setSelectedLink(linkSection.EnglishTitle)} href={linkSection.Link}>
        <div className="overflow-hidden aspect-ratio-1x1 mb-2">
          <img loading="lazy" src={linkSection.ImageUrl} alt={linkSection.ImageAlt} />
        </div>
        <span className="navigationHeading">{linkSection.Title}</span>
      </a>
    );
  }

  return (
    <a
      onClick={() => setSelectedLink(linkSection.EnglishTitle)}
      href={linkSection.Link}
      className="btn navigationItem navigationParagraph"
    >
      {linkSection.Title}
    </a>
  );
};
